import { createSlice } from '@reduxjs/toolkit';

const initialState = {    page: '',
    activateEsimStep: 0,
    activateEsimMinStep: 0,
    esimBlockData: {},
    loginDetails: {
        identity: '',
        subscriberNo: '',
        step1Ticket: ''
    },
    esimPrice: '',
    email: '',
    subscriberList: [],
    qrCodeDetails: {
        base64QrCode: '',
        activationCode: '',
        smdp: '',
        accessCode: '',
        appleUniversalLink: '',
        androidUniversalLink: '',
    },
    isGetQrCodeError: false,
    isLoadingQrCode: false,
    checkUserResponse: {
        isJet: false,
        primaryEmail: '',
        idNumber: ''
    },
    orderDetails: {
        orderId: ''
    },
    isWhatsAppActive: false,
    errorDescription: '',
};

const esimQrCodeBlockSlice = createSlice({
    name: 'esimQrCodeBlock',
    initialState: initialState,
    reducers: {
        resetBlock: (state) => initialState,
        initBlock: {
            reducer: (state, action) => {
                if (!action.payload.preservePage) {
                    state.page = action.payload.page;
                }
                state.esimBlockData = action.payload.esimBlockData;
            },
            prepare: (action) => {
                const currentBlock = action.esimQrCodeBlock;
                const esimContentData = currentBlock.esimContentData.expandedValue[0];

                let esimBlockData = {
                    blockId: esimContentData.contentLink.id,
                    upgCourse: esimContentData.upgCourse.value,
                    productId: esimContentData.productId.value,
                    package: esimContentData.package.value,
                    combSeq: esimContentData.combSeq.value,
                    isAdvanceOrder: !!esimContentData.isAdvanceOrder.value,
                    headerRemark: esimContentData.headerRemark.value,
                    cellularDevicesSupportedUrl: esimContentData.cellularDevicesSupportedUrl.value,

                    otpTopIcon: esimContentData.otpTopIcon.value?.url,
                    otpRecievedCodeIcon: esimContentData.otpRecievedCodeIcon.value?.url,
                    otpPhoneTitle: esimContentData.otpPhoneTitle.value,
                    otpPhoneSubTitle: esimContentData.otpPhoneSubTitle.value,
                    otpCodeTitle: esimContentData.otpCodeTitle.value,
                    otpCodeSubTitle: esimContentData.otpCodeSubTitle.value,

                    whatIsEsimPopupText: esimContentData.whatIsEsimPopupText.value,
                    deleteEsimPopupText: esimContentData.deleteEsimPopupText.value,
                    disconnectLinePopupText: esimContentData.disconnectLinePopupText.value,

                    isDisplayWhatIsEsimPopup: !!esimContentData.isDisplayWhatIsEsimPopup.value,
                    //chooseSubscriberPageTextList: getTextWithIconList(esimContentData.chooseSubscriberPageTextList.value),
                    instructionsPageTextList: getTextWithIconList(esimContentData.instructionsPageTextList.value),
                    videoPageTextList: getTextWithIconList(esimContentData.videoPageTextList.value),
                    scanQrFromMobileUrl: esimContentData.scanQrFromMobileUrl.value,
                    esimActivateVideoAndroidUrl: esimContentData.esimActivateVideoAndroidUrl.value,
                    esimActivateVideoIosUrl: esimContentData.esimActivateVideoIosUrl.value,
                    isDisplayReplaceSimCheckbox: !!esimContentData.isDisplayReplaceSimCheckbox.value,

                    instructionsTextAndroid: esimContentData.instructionsTextAndroid.value,
                    instructionsTextIos: esimContentData.instructionsTextIos.value,
                };

                let payload = {
                    page: 'activateEsimPage',
                    esimBlockData: esimBlockData,
                    preservePage: !!action.preservePage,
                };
                return { payload: payload };
            }
        },
        goToPage: (state, action) => {
            state.page = action.payload;
            window.scrollTo(0, 0);
        },
        goToPageWithoutHistory: (state, action) => {
            state.page = action.payload;
            window.scrollTo(0, 0);
            if (typeof window !== 'undefined' && action.payload) {
                window.history.replaceState(
                    null,
                    '',
                    `${window.location.pathname}${window.location.search}#${action.payload}`,
                );
            }
        },
        setActivateEsimStep: (state, action) => {
            state.activateEsimStep = action.payload;
        },
        setActivateEsimMinStep: (state, action) => {
            state.activateEsimMinStep = action.payload;
        },
        setIsLoadingQrCode: (state, action) => {
            state.isLoadingQrCode = action.payload;
        },
        setIsGetQrCodeError: (state, action) => {
            state.isGetQrCodeError = action.payload;
        },
        setQrCodeDetails: (state, action) => {
            state.qrCodeDetails = action.payload;
        },
        setLoginDetails: (state, action) => {
            state.loginDetails.identity = action.payload.identity ? action.payload.identity : state.loginDetails.identity;
            state.loginDetails.subscriberNo = action.payload.subscriberNo ? action.payload.subscriberNo : state.loginDetails.subscriberNo;
            state.loginDetails.otpTicketId = action.payload.otpTicketId ? action.payload.otpTicketId : state.loginDetails.otpTicketId;
        },
        setErrorPage: (state, action) => {
            window.scrollTo(0, 0);
            state.errorDescription = action.payload.errorDescription;
            state.page = 'errorPage';
        },
        reportDWH: (state, action) => { },
    },
    extraReducers: (builder) => {
        builder.addCase('esimQrCodeBlock/checkIfWhatsAppActiveAsync/fulfilled', (state, action) => {
            state.isWhatsAppActive = !!action.payload?.Body?.isWhatsAppActive;
        });
    },
});

export const {
    resetBlock,
    initBlock,
    goToPage,
    goToPageWithoutHistory,
    setActivateEsimStep,
    setActivateEsimMinStep,
    setIsLoadingQrCode,
    setIsGetQrCodeError,
    setQrCodeDetails,
    setLoginDetails,
    setErrorPage,
    reportDWH
} = esimQrCodeBlockSlice.actions;

export default esimQrCodeBlockSlice.reducer;


function getTextWithIconList(list) {
    if (!list) { return []; }
    const textWithIconList = list.map(item => {
        return {
            icon: item.icon,
            title: item.title,
            text: item.text,
            isBoldText: !!item.isBoldText
        }
    });
    return textWithIconList;
}
